import { authFetch } from 'utils/auth-fetch';
import { getApiUrl } from 'utils/config';
import { isInIframe } from 'utils/iframe';
/**
 * Returns a URL to download all given file objects.
 * @param files File objects to download.
 * @returns Download URL.
 */
export const getMultiFileDownloadUrl = (files) => {
    const ids = files.map((file) => file.id);
    return `${getApiUrl()}/api/v1/object-data?ids=${ids.join(',')}`;
};
/**
 * Downloads a file using fetch with Bearer token authentication.
 * Used in iFrame context where cookies are blocked by third-party cookie
 * restrictions. Falls back to standard <a href> download in normal context.
 *
 * @param url The download URL.
 * @param filename The filename for the downloaded file.
 */
export const authDownloadFile = async (url, filename) => {
    const response = await authFetch(url);
    if (!response.ok) {
        throw new Error(`Download failed: ${response.status} ${response.statusText}`);
    }
    const blob = await response.blob();
    const blobUrl = URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = blobUrl;
    anchor.download = filename;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
    URL.revokeObjectURL(blobUrl);
};
/**
 * Downloads multiple files using authenticated fetch.
 * Used in iFrame context for bulk downloads.
 *
 * @param files File objects to download.
 */
export const authDownloadFiles = async (files) => {
    const url = getMultiFileDownloadUrl(files);
    const filename = files.length === 1 ? files[0].name : 'skyla-download.zip';
    await authDownloadFile(url, filename);
};
/**
 * Whether downloads require authenticated fetch (iFrame context).
 * In normal context, <a href> links with cookies work fine.
 */
export const needsAuthDownload = () => isInIframe();
